import { SignOutIcon } from "@phosphor-icons/react/SignOut";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useAuthentication } from "@/Slices/authenticationSlice";

/**
 * "Sign Out" item for the user menu. Owns the sign-out call itself (menu
 * items must encapsulate their handler, not receive it via props).
 *
 * `tone="danger"` rather than a red class: it turns the whole row red, and the
 * icon inherits that because a non-neutral tone is the one case where the menu
 * doesn't paint the icon brand blue. Highlighting still flips both to white, so
 * the red never lands on the blue selection.
 */
export function NavBarSignOutButton() {
  const { signOut } = useAuthentication();
  return (
    <Button icon={SignOutIcon} tone="danger" onClick={signOut}>
      Sign Out
    </Button>
  );
}
